module.exports = __webpack_public_path__ + "img/harmony_03.d3acc679.jpg";